<template>
  <CDataSearchForm class="w-data-search-form" v-bind="formAttrs"></CDataSearchForm>
</template>

<script setup lang="ts">
import { _, computed, useCurrentAppInstance } from '@zto/zpage'

const props = defineProps<{
  schema: Record<string, any>
}>()

const app = useCurrentAppInstance()

const wSchema = app.useComputedWidgetSchema(props.schema || {})

const formAttrs = computed(() => {
  return _.omit(wSchema.value, ['type'])
})
</script>

<style lang="scss" scoped></style>
